const ContactFirstLoad = () => {
  document?.getElementById("root")?.scrollIntoView({
    // behavior: "smooth",
    behavior: "auto",
    block: "start",
  });
};

export default ContactFirstLoad;
